export default __webpack_public_path__ + "eng.2440178.png";